// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3YHQz","title":"AfterBackImages_title__3f5ZZ","images":"AfterBackImages_images__1LdXV"};